import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  ProductList: {
    width: 550,
  },
  table: {
    borderCollapse: 'unset',
  },
  tableCell: {
    fontSize: '12px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    borderWidth: 1,
    color: '#666666',
    whiteSpace: 'nowrap',
    lineHeight: '20px',
    textTransform: 'capitalize',
    padding: '12px 10px',
  },
  tableHead: {
    fontSize: '14px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#666666',
    paddingTop: '12px',
    paddingBottom: '12px',
    lineHeight: '18px',
  },
}));
